"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var makeNavBarStyles = function () {
    var _a, _b;
    var theme = (0, react_1.useTheme)();
    return {
        container: (0, react_1.css)((_a = {
                height: 45
            },
            _a[theme.breakpoints.up('tabletSmall')] = {
                height: 55,
            },
            _a.width = '100%',
            _a.display = 'flex',
            _a.flexDirection = 'row',
            _a)),
        space: (0, react_1.css)({
            width: theme.mvf.spacing.small,
        }),
        continueButton: (0, react_1.css)({
            width: '100%',
            height: '100%',
            '& .MuiButtonBase-root': {
                borderRadius: '6px',
                boxShadow: theme.mvf.boxShadow.navigation.primary,
                '@media (hover: hover)': {
                    '&:hover': {
                        boxShadow: theme.mvf.boxShadow.navigation.secondary,
                    },
                },
            },
        }),
        backButton: (0, react_1.css)({
            height: '100%',
            '& .MuiButtonBase-root': (_b = {
                    minWidth: '45px !important'
                },
                _b[theme.breakpoints.up('tabletSmall')] = {
                    minWidth: '55px !important',
                },
                _b.borderRadius = '6px',
                _b['@media (hover: hover)'] = {
                    '&:hover': {
                        boxShadow: theme.mvf.boxShadow.navigation.secondary,
                    },
                },
                _b),
        }),
    };
};
exports.default = makeNavBarStyles;
//# sourceMappingURL=makeNavBarStyles.js.map